import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {MessagesAPI} from '@fantasmagames/slot/src/logic/relax/MessagesAPI';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';

export class AutoplayInProgressState extends ModuleState<null, AutoplayHandlerModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopClicked);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
		this.on(FlowModuleEvents.WON_BIG_WIN, this.onBigWin);
		this.on(FlowModuleEvents.NO_WIN, this.onNoWin);
		this.on(FlowModuleEvents.WON, this.onWin);
		this.on(MessagesAPI.AUTOPLAY_PAUSED, this.onAutoplayPaused);
		this.on(MessagesAPI.GAME_HARD_PAUSED, this.onAutoplayPaused);
		this.on(MainMenuEvents.MAIN_MENU_OPEN, this.onAutoplayPaused);
	}

	protected onAutoplayPaused(): void {
		this.module.gotoState(AutoplayHandlerModule.PAUSED);
	}

	protected onAutoplayStopClicked(): void {
		this.module.stopAutoplay();
		this.module.gotoState(AutoplayHandlerModule.BASIC);
	}

	protected onCanSpin(): void {
		this.module.tryToStartSpin();
	}

	protected onFreeSpinsWin(): void {
		this.module.stopAutoplayOnReachingLimits();
	}

	protected onBigWin(): void {
		this.module.bigWinUpdate();
	}

	protected onNoWin(): void {
		this.module.stopAutoplayOnReachingLimits();
	}

	protected onWin(): void {
		this.module.winUpdate();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/states/AutoplayInProgressState.ts